/* System defined core library */
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Observer } from 'rxjs';
import { map } from 'rxjs/operators';

/* User defined library/components */
import { BootstrapParams } from '../../../../bootstrap-params';
import { HttpService } from '../../../core/http.service';
import { MetricApiService } from './metric-api.service';

/* User defined models */
import { EmailResponse } from '../../../shared/models/common/shared.model';
import { AppointmentDetail } from '../../../shared/models/scheduling/appointmentdetail.model';

/* User defined enums/constants */
import { LogLevel } from '../../../shared/enums/scheduling.enum';


@Injectable()
export class MessagingApiService {
  private emailSource = new BehaviorSubject<EmailResponse>(null);
  emailResponse = this.emailSource.asObservable();
  constructor(private httpService: HttpService,
    private bootstrapParams: BootstrapParams,
    private metricApiService: MetricApiService
  ) {

  }

  text(contact: string, type: string, confirmationNumber: string): Observable<EmailResponse> {
    if (type) {
      return new Observable((observer: Observer<EmailResponse>) => {

        this.httpService.post(this.bootstrapParams.MessagingRootApiUrl + 'api/v1/messaging/', {
          "Number": confirmationNumber,
          "Type": type,
          "Contact": contact
        })
          .pipe(map(this.getSingleResult))
          .subscribe({
            next: (rArray) => {
              let emailResponse: EmailResponse = new EmailResponse();
              emailResponse.successful = rArray.successful;
              emailResponse.href = rArray.href;
              emailResponse.name = rArray.name;
              emailResponse.type = rArray.type;
              this.emailSource.next(emailResponse);
              this.metricApiService.log(LogLevel.Info, `Successfully posted SMS text message: ${confirmationNumber}`);
              observer.next(emailResponse);
              observer.complete();
            },
            error: (err) => {
              let emailResponse: EmailResponse = new EmailResponse();
              emailResponse.successful = false;
              emailResponse.href = confirmationNumber;
              emailResponse.name = contact;
              emailResponse.type = "Text";
              this.metricApiService.log(LogLevel.Error, `Posting SMS text message failed. ${confirmationNumber}`);
              observer.next(emailResponse);
              observer.complete();
            }
          });
      });
    }
  }

  email(emailTo: string, emailType: string, confirmationNumber: string): Observable<EmailResponse> {
    var mailto_link = 'mailto:' + emailTo;
    if (emailType) {
      return new Observable((observer: Observer<EmailResponse>) => {

        this.httpService.post(this.bootstrapParams.MessagingRootApiUrl + 'api/v1/messaging/', {
          "Number": confirmationNumber,
          "Type": emailType
        })
          .pipe(map(this.getSingleResult))
          .subscribe({
            next: (rArray) => {
              let emailResponse: EmailResponse = new EmailResponse();
              emailResponse.successful = rArray.successful;
              emailResponse.href = rArray.href;
              emailResponse.name = rArray.name;
              emailResponse.type = rArray.type;
              this.emailSource.next(emailResponse);
              this.metricApiService.log(LogLevel.Info, `Successfully posted ${emailType} Email: ${confirmationNumber}`);
              observer.next(emailResponse);
              observer.complete();
            },
            error: (err) => {
              let emailResponse: EmailResponse = new EmailResponse();
              emailResponse.successful = false;
              emailResponse.href = confirmationNumber;
              emailResponse.name = emailTo;
              emailResponse.type = emailType;
              this.metricApiService.log(LogLevel.Error, `Posting ${emailType} Email failed: ${confirmationNumber}`);
              observer.next(emailResponse);
              observer.complete();
            }
          });
      });
    }
  }

  sendConfirmation(confirmationNumbers: string[]): Observable<any> {
    return new Observable((observer: Observer<any>) => {
      this.httpService.post(this.bootstrapParams.MessagingRootApiUrl + 'api/v1/messaging/confirmation', {
        confirmationNumbers
      })
        .pipe(map(this.getSingleResult))
        .subscribe({
          next: (rArray) => {
            this.metricApiService.log(LogLevel.Info, `Successfully posted Confirmation Email: ${confirmationNumbers}`);
            observer.next(rArray);
            observer.complete();
          },
          error: (err) => {
            this.metricApiService.log(LogLevel.Error, `Posting Confirmation Email failed: ${confirmationNumbers}`);
            observer.next(err);
            observer.complete();
          }
        });
    });
  }

/**
* Helper method to send emails for all the sessions in a booked appointment
* @param appointmentData
* @param emailto
* @param emailtype
*/
  sendAllEmailsInBooking(appointmentData: AppointmentDetail[], emailto: string, emailtype: string): Observable<EmailResponse> {
    let emailResps: EmailResponse[] = [];
    return new Observable((observer: Observer<EmailResponse>) => {
     // appointmentData.forEach((appointment) => {
        if (appointmentData.length > 0) {
          appointmentData.forEach((data) => {
            this.email(emailto, emailtype, data.ConfirmationNumber).subscribe({
              next: (mailResponse) => {
                let emailResp: EmailResponse = new EmailResponse();
                emailResp.successful = mailResponse.successful;
                emailResp.emailType = (emailtype == "eConfirmation") ? "Confirmation" : "Receipt";
                emailResps.push(emailResp);
                if (emailResps.length == appointmentData.length) {
                  this.setEmailState(emailResp);
                  observer.next(emailResp);
                  observer.complete();
                }
              },
              error: (err) => {
                let emailResponse: EmailResponse = new EmailResponse();
                observer.next(emailResponse);
                observer.complete();
              }
            });
          });
        }
      })
    //});
  }

  private getSingleResult(apiResponse: any): any {
    return apiResponse;
  }

  setEmailState(emailResponse: EmailResponse) {
    this.emailSource.next(emailResponse);
  }
}
